"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentUser = exports.USER_KEY = exports.TOKEN_KEY = exports.ANALYTICS_KEY = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var ANALYTICS_KEY = 'ajs_user_traits';
exports.ANALYTICS_KEY = ANALYTICS_KEY;
var TOKEN_KEY = 'token';
exports.TOKEN_KEY = TOKEN_KEY;
var USER_KEY = 'guesty_user_data';
exports.USER_KEY = USER_KEY;

var getCurrentUser = function getCurrentUser() {
  try {
    var userData = JSON.parse(localStorage.getItem(USER_KEY));

    if (userData) {
      return (0, _extends2["default"])({}, userData, {
        name: userData.fullName,
        userId: userData._id
      });
    }

    var analyticsData = JSON.parse(localStorage.getItem(ANALYTICS_KEY));

    if (analyticsData) {
      return (0, _extends2["default"])({}, analyticsData, {
        userId: analyticsData.user_id
      });
    }

    var tokenData = (0, _jwtDecode["default"])(localStorage.getItem(TOKEN_KEY));

    if (tokenData) {
      return (0, _extends2["default"])({}, tokenData, {
        email: tokenData.name,
        name: tokenData.fullName
      });
    }

    throw new Error('getCurrentUser unexpectedly did not find any local data');
  } catch (error) {
    return {};
  }
};

exports.getCurrentUser = getCurrentUser;